/* 
Copyright (c) Karsten Jeske and John Firth
This source code is licensed under the proprietary license found in the
LICENSE file in the root directory of this source tree.
*/

import DisclaimerFooter from "components/DisclaimerFooter"
import { useEffect } from "react"
import { Link } from "react-router"
import { pageMetaData, updateMetaTags } from "utils/metaTags"

const Disclaimers = () => {
  // Update meta tags for disclaimers page
  useEffect(() => {
    const { title, description, keywords } = pageMetaData.disclaimers
    updateMetaTags(title, description, keywords)
  }, [])
  return (
    <div className="pt-1 pb-3">
      <h1 className="fs-4 pb-3">Disclaimers</h1>

      {/* AIDEV-NOTE: #522 items 5 and 6 - this date is legally operative, not decoration.
          A disclaimer defence rests on showing what a given user saw on a given day, and
          this page had no date at all while Terms and Privacy both did. Update it whenever
          the wording below changes, and never as a routine touch. Guarded by
          utils/legalCopy.test.ts, which requires a parseable date on all three legal pages. */}
      <p>
        <strong>Last Updated:</strong> August 20, 2026
      </p>

      <h2 className="fs-5 mt-4 mb-3">Educational Purpose</h2>
      <p>
        Safe Retirement Spending (saferetirementspending.com) is provided for educational purposes
        only. It cannot be considered advice or guidance for investment decisions or, for that
        matter, any other decisions. If uncertain, always consult an investment advisor and/or
        accountant.
      </p>

      <h2 className="fs-5 mt-4 mb-3">No Accuracy Guarantees and Limitation of Liability</h2>
      <p>
        Safe Retirement Spending makes no representations of the accuracy, completeness,
        currentness, suitability, or validity of any information on this site. It will not be liable
        for any errors, omissions, or delays in this information or any losses, injuries, or damages
        arising from its display or use. The calculator uses historical data which may not predict
        future market conditions or outcomes. Your actual investment results will likely differ from
        projections.
      </p>

      <h2 className="fs-5 mt-4 mb-3">No Financial Relationship</h2>
      <p>
        Safe Retirement Spending is not affiliated with, endorsed by, or in any financial
        relationship with any investment company, brokerage, or financial product. We do not receive
        compensation for any investments you may make based on our calculator.
      </p>

      <h2 className="fs-5 mt-4 mb-3">External Links</h2>
      <p>
        Safe Retirement Spending assumes no responsibility for the accuracy, completeness,
        currentness, suitability, and validity of any and all external links you find here.
        References to third-party resources are provided for informational purposes and do not
        constitute endorsement.
      </p>

      <p className="mt-4">
        For additional information about using this website, please review our
        <Link to="/terms/" className="ms-1">
          Terms of Service
        </Link>{" "}
        and
        <Link to="/privacy/" className="ms-1">
          Privacy Policy
        </Link>
        .
      </p>

      <DisclaimerFooter />
    </div>
  )
}

export default Disclaimers
